export type SlideVisualKind =
  | 'agenda'
  | 'case-study'
  | 'closing'
  | 'cover'
  | 'hazard'
  | 'ky'
  | 'photo'
  | 'procedure'
  | 'quiz'
  | 'reference'
  | 'site'
  | 'summary'
  | 'theme';

export function slideBodyLines(body: string): string[] {
  return body
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function slideVisualKind(type: string, title: string): SlideVisualKind {
  if (type === 'COVER') return 'cover';
  if (type === 'CONTEXT') return 'theme';
  if (type === 'AGENDA') return 'agenda';
  if (type === 'PHOTO_CONTEXT') return 'photo';
  if (type === 'KY_QUESTION') return 'ky';
  if (type === 'TEST_QUESTION') return 'quiz';
  if (type === 'CASE_STUDY') return 'case-study';
  if (type === 'HAZARD_FACTOR' || /注意|危険|ヒヤリ/u.test(title)) return 'hazard';
  if (type === 'PREVENTION') return 'procedure';
  if (type === 'SUMMARY') return 'summary';
  if (type === 'DISCLAIMER') return 'closing';
  if (type === 'LATEST_SAFETY' || type === 'SAFETY_SOURCE') return 'reference';
  return 'site';
}

export function slideVisualLabel(kind: SlideVisualKind): string {
  const labels: Record<SlideVisualKind, string> = {
    agenda: 'TRAINING FLOW',
    'case-study': 'CASE REVIEW',
    closing: 'FINAL CHECK',
    cover: 'SAFETY TRAINING',
    hazard: 'RISK FOCUS',
    ky: 'KY DISCUSSION',
    photo: 'SITE VIEW',
    procedure: 'SAFE ACTION',
    quiz: 'KNOWLEDGE CHECK',
    reference: 'APPROVED SOURCE',
    site: 'SITE CONTEXT',
    summary: 'KEY POINTS',
    theme: 'TODAY’S THEME',
  };
  return labels[kind];
}
